import { render, staticRenderFns } from "./orderClassification.vue?vue&type=template&id=e7fcdfde&scoped=true&"
import script from "./orderClassification.vue?vue&type=script&lang=js&"
export * from "./orderClassification.vue?vue&type=script&lang=js&"
import style0 from "./orderClassification.vue?vue&type=style&index=0&id=e7fcdfde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fcdfde",
  null
  
)

export default component.exports